import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { Icons, Layout, MUI, Typography } from '@styles';

const CommentDialog = (props) => {
  const {
    action,
    open,
    onClose,
    onRejectConfirmation,
    onApproveConfirmation
  } = props;

  const values = {
    comment: ''
  };

  const schema = Yup.object({
    comment: Yup.string()
      .min(2, i18n.t('FormsGeneralTexts.min2Chars'))
      .max(500, i18n.t('FormsGeneralTexts.max500Chars'))
      .required('*')
  });

  return (
    <Formik
      initialValues={values}
      validationSchema={schema}
      isInitialValid={schema.isValidSync(values)}
      onSubmit={(values, { resetForm, setSubmitting }) => {
        action === 'reject' ? onRejectConfirmation(values, resetForm, setSubmitting) : onApproveConfirmation(values, resetForm, setSubmitting);
      }}
    >
      {(formikProps) => (
        <MUI.Dialog
          open={open}
          onClose={onClose}
          maxWidth="sm"
        >
          <MUI.DialogTitle>
            {action === 'reject' ? (
              i18n.t('Shedule.rejectSchedule')
            ) : (
                i18n.t('Shedule.approveSchedule')
              )}
            <MUI.DialogBoxClose onClick={onClose}>
              <Icons.Close />
            </MUI.DialogBoxClose>
          </MUI.DialogTitle>

          <MUI.DialogContent>
            <MUI.Box padding="8px">
              <Typography.Text>
                {action === 'reject' ? (
                  i18n.t('Shedule.whyRejectingSchedule')
                ) : (
                    i18n.t('Shedule.whyApproveSchedule')
                  )}
              </Typography.Text>
            </MUI.Box>
            {/* Comentario */}
            <MUI.Box padding="8px">
              <MUI.TextField
                multiline
                label={i18n.t('GenericMessages.comment')}
                type="text"
                name="comment"
                value={formikProps.values.comment}
                characterLimit={500}
                onBlur={formikProps.handleBlur}
                onChange={formikProps.handleChange}
                error={Boolean(formikProps.touched.comment && formikProps.errors.comment)}
                helperText={formikProps.touched.comment && formikProps.errors.comment}
                inputProps={{ maxlength: '500' }}
              />
            </MUI.Box>
          </MUI.DialogContent>

          <MUI.DialogActions>
            <Layout.BoxRequired>
              {`* ${i18n.t('FormsGeneralTexts.required')}`}
            </Layout.BoxRequired>
            <MUI.ButtonText onClick={onClose}>
              {i18n.t('DialogConfirm.cancel')}
            </MUI.ButtonText>
            <MUI.ButtonCTA
              type="button"
              color="primary"
              disabled={!formikProps.isValid || formikProps.isSubmitting}
              onClick={formikProps.handleSubmit}
            >
              {action === 'reject' ? (
                i18n.t('DialogConfirm.reject')
              ) : (
                  i18n.t('DialogConfirm.approve')
                )}
            </MUI.ButtonCTA>
          </MUI.DialogActions>
        </MUI.Dialog>
      )}
    </Formik>
  );
};

CommentDialog.propTypes = {
  // String que indica la acción de modal (aprobar o rechazar)
  action: PropTypes.oneOf(['approve', 'reject']),
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta cuando se cierra el modal.
  onClose: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se rechaza el horario.
  onRejectConfirmation: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se aprueba el horario.
  onApproveConfirmation: PropTypes.func.isRequired,
  // Formik props.
  values: PropTypes.any,
  errors: PropTypes.any,
  isValid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default CommentDialog;
